// Lightweight geocoding via OpenStreetMap Nominatim.
export async function geocode(query) {
  if (!query || query.trim().length < 2) return [];
  const url = `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=5&q=${encodeURIComponent(query)}`;
  try {
    const res = await fetch(url, { headers: { "Accept-Language": "it" } });
    const data = await res.json();
    return data.map((d) => ({
      label: d.display_name,
      city: d.address?.city || d.address?.town || d.address?.village || d.name || d.display_name.split(",")[0],
      lat: parseFloat(d.lat),
      lng: parseFloat(d.lon),
    }));
  } catch {
    return [];
  }
}
